import React from "react";
import HeaderModal from "components/modal/HeaderModal";
import { displayIcon } from "variables/icons";

const InteractiveView = ({ 
  isModalOpen, 
  selectedAnnouncement,
  closeModalHandler,
  selectedColorOption,
}) => {

  return (
    <>
      <HeaderModal
        group="announcement"
        open={isModalOpen}
        onClose={closeModalHandler}
        colorTheme="!p-0 backdrop-blur-lg"
        useCustomClass={true}
        descriptionClass="text-2xl text-white font-medium"
        description={selectedAnnouncement.ann_title}
        width={550}
        backgroundStyle={
          <div className="absolute inset-0 pointer-events-none opacity-10">
            <div className="absolute top-0 right-0 w-64 h-64 bg-white rounded-full -mr-32 -mt-32"></div>
            <div className="absolute bottom-0 left-0 w-48 h-48 bg-white rounded-full -ml-24 -mb-24"></div>
          </div>
        }
        icon={
          <div className="w-16 h-16 rounded-2xl shadow-lg bg-white/20 flex items-center justify-center">
              {displayIcon(selectedAnnouncement.ann_icon, "w-8 h-8 text-white" )}
          </div>
        }
        title={
          <div className="flex items-center gap-2 mb-2">
            <span className="inline-flex items-center justify-center rounded-lg border px-2 py-0.5 font-medium text-[10px] uppercase tracking-wider bg-white/20 border-white/30 text-white">
              {selectedAnnouncement.category_name}
            </span>
          </div>
        }
        bgcolor={`${selectedColorOption?.gradient || ""}`}
        footer={
          <div className="p-4 flex gap-8 items-center justify-center">
            <div className="p-2 gradient-icon bg-text !rounded-full gradient-blue">
              {displayIcon("ThumbsUp", "w-6 h-6" )}
            </div>
            <div className="p-2 gradient-icon bg-text !rounded-full gradient-red">
              {displayIcon("Heart", "w-6 h-6" )}
            </div>
            <div className="p-2 gradient-icon bg-text !rounded-full gradient-emerald">
              {displayIcon("Coffee", "w-6 h-6" )}
            </div>
            <div className="p-2 gradient-icon bg-text !rounded-full gradient-purple">
              {displayIcon("Sparkles", "w-6 h-6" )}
            </div>
          </div>
        }
      >
        <div className="space-y-4 pt-4">
          {selectedAnnouncement.ann_additional_info && (
            <div className={`p-4 rounded-lg card-border-s ${selectedColorOption.addInfoCard}`}>
              <div className="flex items-start gap-3">
                {displayIcon("Quote", "w-5 h-5 icon-color flex-shrink-0")}
                <div>
                  {selectedAnnouncement.ann_additional_info_label && (
                    <p className="label-color text-2xl mb-1 font-semibold">{selectedAnnouncement.ann_additional_info_label}</p>
                  )}
                  <p className="text-color">
                    {selectedAnnouncement.ann_additional_info}
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
      </HeaderModal>
    </>
  );
};
export default InteractiveView;
